import React, { useState, useEffect } from "react";
import {
  Table,
  TableRow,
  TableBody,
  useTheme,
  Box,
  Typography,
  TableContainer,
} from "@mui/material";
import VantageListHead from "../../../../../component/ListHead/SignalList";
import {
  Tablecell,
  applySortFilter,
  calculateAndFormatNoAbs,
  getComparator,
  hashAction,
  hashPosition,
} from "../../../../../component/Methods";

const Order = ({ orders, tableHeader, brokers }) => {
  const theme = useTheme();
  const [data, setData] = useState([]);
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("strategy");



  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  useEffect(() => {
    if (orders) {
      const formattedData = Object?.entries(orders)?.flatMap(([parentStrategy, positions]) => {
        if (Array.isArray(positions)) {
          return positions.map(position => ({
            brokerName: brokers?.find(broker => broker?.brokerId === position?.broker)?.abbreviation,
            Pstrategy: parentStrategy,
            tradeType: hashAction(position?.action) + hashPosition(position?.position),
            ...position,
          }));
        }
        return [{
          brokerName: brokers?.find(broker => broker?.brokerId === positions?.broker)?.abbreviation,
          Pstrategy: parentStrategy,
          tradeType: hashAction(positions?.action) + hashPosition(positions?.position),
          ...positions,
        }];
      });

      
      
      const filteredUsers = applySortFilter(
        formattedData,
        getComparator(order, orderBy)
      );
      setData(filteredUsers);
    }
  }, [order, orderBy, orders]);

 

  return (
    <>
      <Box
        sx={{
          border: `100px ${theme.palette.lightGrey.tableHeader}`,
          borderRadius: "4px",
          marginTop: "1px",
          width: "80%",
          marginRight: 1,
        }}
      >
        <Typography sx={{ fontWeight: "bold", fontSize: "20px", mb: 1 }}>
          Order Generated by Crossing
        </Typography>

        <TableContainer 
          style={{ 
            height: "auto",
            maxHeight: "300px",
            minHeight: "50px"
          }}
        >
          <Table
            size="small"
            stickyHeader
            aria-label="a dense table"
            sx={{
              height: "max-content",
            }}
          >
            <VantageListHead
              order={order}
              orderBy={orderBy}
              headLabel={tableHeader}
              noStatus={true}
              customizeFont={12}
              rowCount={data.length}
              onRequestSort={handleRequestSort}
            />
            <TableBody>
              {data?.map((row, index) => (
                <TableRow
                  key={index}
                  sx={{
                    "&:hover": {
                      background: theme.palette.grey[200],
                      cursor: "pointer",
                    },
                  }}
                >
                  <Tablecell
                    align="left"
                    style={{
                      fontSize: "12px",
                      paddingLeft: "10px",
                      borderLeft: "none",
                      borderRight: "none",
                      color: theme.palette.text.primary,
                      borderColor: theme.palette.divider,
                    }}
                  >
                    {row?.Pstrategy}
                  </Tablecell>
                  <Tablecell
                    align="right"
                    style={{
                      fontSize: "12px",
                      paddingRight: "10px",
                      borderLeft: "none",
                      borderRight: "none",
                      color: theme.palette.text.primary,
                      borderColor: theme.palette.divider,
                    }}
                  >
                    {calculateAndFormatNoAbs(row?.shareCount)}
                  </Tablecell>

                  <Tablecell
                    align="right"
                    style={{
                      fontSize: "12px",
                      paddingRight: "10px",
                      borderLeft: "none",
                      borderRight: "none",
                      color: theme.palette.text.primary,
                      borderColor: theme.palette.divider,
                    }}
                  >
                    {row?.tradeType}
                  </Tablecell>
                  <Tablecell
                    align="right"
                    style={{
                      fontSize: "12px",
                      paddingRight: "10px",
                      borderLeft: "none",
                      borderRight: "none",
                      color: theme.palette.text.primary,
                      borderColor: theme.palette.divider,
                    }}
                  >
                    {row?.custodian}
                  </Tablecell>
                  <Tablecell
                    align="right"
                    style={{
                      fontSize: "12px",
                      paddingRight: "10px",
                      borderLeft: "none",
                      borderRight: "none",
                      color: theme.palette.text.primary,
                      borderColor: theme.palette.divider,
                    }}
                  >
                    {row?.brokerName}
                  </Tablecell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </>
  );
};

export default Order;
